import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { INotification } from "infrastructure/notification";
import { actionProcessing } from "infrastructure/store";
import { getScreenExtraReducers } from "ui/app";

import {
  getInitialRoleMembersHistoryState,
  IRoleMembersHistoryState,
  IRoleMembersHistoryFilter,
  IRoleAssignmentEvent,
  IRoleMembersHistoryInitData
} from "./RoleMembersHistory.state";

const initialState = getInitialRoleMembersHistoryState();

export const roleMembersHistory = createSlice({
  name: "roleMembersHistory",
  initialState: initialState,
  reducers: {
    initRoleMembersHistory: (state: IRoleMembersHistoryState, action: PayloadAction<IRoleMembersHistoryInitData>) => {
      return {
        ...state,
        initData: action.payload
      };
    },
    applyFilter: (state: IRoleMembersHistoryState, action: PayloadAction<IRoleMembersHistoryFilter>) => {
      return {
        ...state,
        filter: { ...state.filter, ...action.payload },
        notifications: []
      };
    },
    loadRoleMembersHistory: actionProcessing.createWithClearNotification((state: IRoleMembersHistoryState) => {
      return {
        ...state,
        isLoading: true
      };
    }),

    loadRoleMembersHistoryCompleted: (state: IRoleMembersHistoryState, action: PayloadAction<IRoleAssignmentEvent[]>) => {
      return {
        ...state,
        isLoading: false,
        data: action.payload
      };
    },
    loadRoleMembersHistoryFailed: (state: IRoleMembersHistoryState, action: PayloadAction<INotification>) => {
      return {
        ...state,
        notifications: [...state.notifications, action.payload],
        isLoading: false
      };
    },
    reset: actionProcessing.createWithClearNotification(() => {
      return {
        ...initialState
      };
    })
  },
  extraReducers: { ...getScreenExtraReducers<IRoleMembersHistoryState>("notifications", initialState) }
});
